// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__t4Cox","socialsReverse":"Socials_socialsReverse__wNT4z","link":"Socials_link__uD5W1","img":"Socials_img__UlNgN"};